import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "inputState", "id", "label", "showCharactersCount", "maxLength"];
import { forwardRef, useState } from 'react';
import { clsx } from 'clsx';
import { inputClassName, MAX_LENGTH } from "../constants";
import { getInitialCharacterCount } from "../utils/getInitialCharacterCount";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var InputElement = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _inputProps$ariaLabe;
  var size = _ref.size,
    inputState = _ref.inputState,
    id = _ref.id,
    label = _ref.label,
    _ref$showCharactersCo = _ref.showCharactersCount,
    showCharactersCount = _ref$showCharactersCo === void 0 ? false : _ref$showCharactersCo,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? MAX_LENGTH : _ref$maxLength,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(getInitialCharacterCount(inputProps)),
    _useState2 = _slicedToArray(_useState, 2),
    characterCount = _useState2[0],
    setCharacterCount = _useState2[1];
  var handleInputChange = function handleInputChange(event) {
    var onChange = inputProps.onChange;
    if (onChange) onChange(event);
    if (!showCharactersCount) return;
    var value = event.target.value;
    setCharacterCount(value.length);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      "aria-errormessage": "".concat(id, "Error"),
      "aria-invalid": inputState === 'error',
      "aria-label": (_inputProps$ariaLabe = inputProps['aria-label']) !== null && _inputProps$ariaLabe !== void 0 ? _inputProps$ariaLabe : label,
      maxLength: maxLength
    }, inputProps), {}, {
      className: clsx(inputClassName, inputProps.className),
      onChange: handleInputChange
    })), showCharactersCount && /*#__PURE__*/_jsxs("span", {
      className: clsx('tw-font-body5 tw-mr-1.2', inputState === 'disabled' ? 'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-400'),
      children: [characterCount, "/", maxLength]
    })]
  });
});
InputElement.displayName = 'InputElement';
export default InputElement;